module.exports = __webpack_public_path__ + "img/fat2.caa9b47e.png";